export default {
    defaultProps: {
        variant: "contained",
    },
    styleOverrides: {
        root: {
            textTransform: "none",
        },
        outlined: {
            borderColor: "currentColor",
        },
    },
};
